import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import PageContainer from "../components/PageContainer";
import { Helmet } from 'react-helmet-async';
import logo from '../static/images/temporary_logo.png';

/**
 * Impressum — testo fornito dal cliente TicinoWild SNC (2026-07-13).
 * Nota legale richiesta dai requisiti di onboarding TWINT/Stripe: ragione sociale
 * con forma giuridica, indirizzo completo e contatto devono essere visibili sul sito.
 * Multilingua (sezione ImpressumPage nei translation.json); i dati legali (ragione
 * sociale, indirizzo, UID, email) sono identici in tutte le lingue. Pre-renderizzata
 * via react-snap con la lingua di fallback (it).
 */
const Impressum = () => {
    const { t } = useTranslation();
    return (
        <PageContainer items="center" px="4">
            <Helmet>
                <title>Impressum - TicinoWild</title>
                <meta name="description" content="Impressum di TicinoWild SNC: titolare del sito, sede legale, UID/IDI e contatti della piattaforma per esperienze outdoor in Svizzera." />
                <link rel="canonical" href="https://ticinowild.ch/impressum" />
                <meta property="og:title" content="Impressum - TicinoWild" />
                <meta property="og:description" content="Impressum di TicinoWild SNC: titolare del sito, sede legale, UID/IDI e contatti della piattaforma per esperienze outdoor in Svizzera." />
                <meta property="og:url" content="https://ticinowild.ch/impressum" />
                <meta name="twitter:title" content="Impressum - TicinoWild" />
                <meta name="twitter:description" content="Impressum di TicinoWild SNC: titolare del sito, sede legale, UID/IDI e contatti della piattaforma per esperienze outdoor in Svizzera." />
            </Helmet>
            <div className="flex flex-col gap-8 max-w-[600px] w-full mt-8 terms">
                <div className="flex flex-col items-center gap-4">
                    <img src={logo} alt="TicinoWild" className="w-24" />
                    <h3 className="font-normal">{t('ImpressumPage.title')}</h3>
                </div>

                <div className="bg-[#f4f7f4] border border-[#dfe8df] rounded-2xl p-6 flex flex-col gap-2">
                    <h4 className="text-[#225424]">{t('ImpressumPage.ownerTitle')}</h4>
                    <p>
                        <b>TicinoWild SNC</b><br />
                        {t('ImpressumPage.legalForm')}<br />
                        Via Carona 13<br />
                        CH-6912 Pazzallo<br />
                        {t('ImpressumPage.country')}
                    </p>
                    <p>
                        UID/IDI: CHE-491.433.783<br />
                        {t('ImpressumPage.emailLabel')}: <a href="mailto:info@ticinowild.ch" className="text-[#225424] underline">info@ticinowild.ch</a>
                    </p>
                </div>

                <div>
                    <h4 className="text-[#225424]">{t('ImpressumPage.infoTitle')}</h4>
                    <p>
                        {t('ImpressumPage.infoWebsitePre')}{' '}
                        <a href="https://www.ticinowild.ch" className="text-[#225424] underline">www.ticinowild.ch</a>
                        {t('ImpressumPage.infoWebsitePost')}
                    </p>
                    <p>
                        {t('ImpressumPage.privacyPre')}{' '}
                        <Link to="/privacy-policy" className="text-[#225424] underline">{t('ImpressumPage.privacyLink')}</Link>.{' '}
                        {t('ImpressumPage.termsPre')}{' '}
                        <Link to="/terms-and-conditions" className="text-[#225424] underline">{t('ImpressumPage.termsLink')}</Link>.
                    </p>
                </div>
            </div>
        </PageContainer>
    )
}

export default Impressum
